export enum EProtectorType {
  Carpet_Protector = 'Carpet Protector',
  Fabric_Protector = 'Fabric Protector',
  Tile_Grout = 'Tile and Grout Sealer',
  Rug_Protector = 'Rug Protector',
}
